import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faq';
import { contact } from '../data/contact';
const ease = [0.22, 1, 0.36, 1] as const;
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  const reduceMotion = useReducedMotion();
  return <section id="faq" aria-labelledby="faq-heading" className="border-t border-line bg-paper px-6 py-24 md:px-16 md:py-32" data-id="element-470" data-mp="2e066s0x25kux">
      <div className="mx-auto grid max-w-[1320px] grid-cols-1 gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.6fr)] lg:gap-24" data-id="element-471" data-mp="292eg1a85g4sb">
        <div data-id="element-472" data-mp="240fbvy4l53ub">
          <h2 id="faq-heading" className="text-[26px] font-normal leading-[34px] tracking-[-0.01em] md:text-[34px] md:leading-[42px]" data-id="element-473" data-mp="244cwypaq45gu">
            Asked in confidence
          </h2>
          <p className="mt-4 max-w-[380px] text-[16px] font-light leading-[26px] text-ink/75" data-id="element-474" data-mp="soej884lov9a">
            Anything else you would like to know? Your partner is one call away.
          </p>
          <a href={contact.phoneHref} className="mt-8 inline-flex border border-ink px-6 py-3 text-[16px] font-medium transition-colors duration-300 hover:bg-ink hover:text-paper" data-id="element-475" data-mp="pih947wlz9u7">
            Call your partner
          </a>
        </div>

        <ul className="border-t border-line" data-id="element-476" data-mp="ki1wjik5i6da">
          {faqs.map((item, i) => {
          const isOpen = open === i;
          const panelId = `faq-panel-${i}`;
          const buttonId = `faq-button-${i}`;
          return <li key={item.question} className="border-b border-line" data-id="element-477" data-mp="bjhl92gx6yz3" data-mpi={i}>
                <h3 data-id="element-478" data-mp="3szzfeawqg8si">
                  <button id={buttonId} type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={panelId} className="flex w-full items-center justify-between gap-6 py-6 text-left text-[18px] font-normal leading-[26px] transition-opacity duration-200 hover:opacity-70 md:text-[20px]" data-id="element-479" data-mp="3t0hjftpmzraz">
                    {item.question}
                    <PlusIcon className={`h-5 w-5 shrink-0 transition-transform duration-300 ease-luxe ${isOpen ? 'rotate-45' : ''}`} strokeWidth={1.25} aria-hidden="true" data-id="element-480" data-mp="1potd4i6o6z48" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-481" data-mp="2ddme4t25fx5p">
                  {isOpen && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={reduceMotion ? {
                opacity: 0
              } : {
                height: 0,
                opacity: 0
              }} animate={reduceMotion ? {
                opacity: 1
              } : {
                height: 'auto',
                opacity: 1
              }} exit={reduceMotion ? {
                opacity: 0
              } : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease
              }} className="overflow-hidden" data-id="element-482" data-mp="28h5d4y9upob7">
                      <p className="max-w-[680px] pb-7 text-[16px] font-light leading-[26px] text-ink/75" data-id="element-483" data-mp="33p7n519xcj17">{item.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}